import { Flavor } from "../../../common/types";

export type Data = {
  flavor: Flavor,
  name: string,
  calorie: string,
  taste: string,
  aroma: string,
  pairsWell: string[]
};

const data: Data[] = [
  {
    flavor: "apple",
    name: "Apple",
    calorie: "251/59",
    taste: "Pleasant sparkling sweetness with a fruity and sour balance",
    aroma: "Fresh apple tuned with floral, green and blooming notes",
    pairsWell: ["Sweet and sour chicken", "Seafood", "Pizza", "Light salad"]
  },
  {
    flavor: "blackberry",
    name: "Blackberry",
    calorie: "250/59",
    taste: "Pleasantly smooth, sweet and slightly sour",
    aroma: "Red berries and floral notes",
    pairsWell: ["Pancakes", "Antipasti / ham / melon", "Fruity salads"]
  },
  {
    flavor: "blueberry",
    name: "Blueberry",
    calorie: "239/57",
    taste: "Pleasant sweetness and slightly sour",
    aroma: "Blueberry combined with floral notes",
    pairsWell: ["Pancakes", "Light pork dishes", "Fruity desserts"]
  },
  {
    flavor: "elderflower",
    name: "Elderflower & Lime",
    calorie: "242/57",
    taste: "Balanced between floral and fruity notes of lime and elderflower",
    aroma: "Floral aroma with a hint of lime",
    pairsWell: ["Pasta carbonara", "Chicken dishes", "Light salad"]
  },
  {
    flavor: "mango",
    name: "Mango & Lime",
    calorie: "242/57",
    taste: "Juicy fruity cider with mango taste and a twist of lime",
    aroma: "Mango with floral notes",
    pairsWell: ["White fish", "Fruity desserts", "Light salad"]
  },
  {
    flavor: "pear",
    name: "Pear",
    calorie: "260/61",
    taste: "Pleasant sweetness and slightly sour combination",
    aroma: "Notes of flowers, orchard and fresh green",
    pairsWell: ["Mild cheeses", "White fish", "Light pork dishes"]
  },
  {
    flavor: "redrhubarb",
    name: "Red Rhubarb",
    calorie: "247/58",
    taste: "Intense and refreshing rhubarb notes balanced by apple flavours",
    aroma: "Dominance of rhubarb with apple aroma",
    pairsWell: ["Pasta carbonara", "Fruit pies / pudding", "Pancakes"]
  },
  {
    flavor: "watermelon",
    name: "Watermelon",
    calorie: "217/51",
    taste: "Fruity and slightly acidic",
    aroma: "Dominance of watermelon aroma with red apple note",
    pairsWell: ["Charcuterie", "Fruity desserts", "Light salad"]
  }
];

export default data;